'use client'

type DoNotSellLinkProps = {
  className?: string
}

export default function DoNotSellLink({ className }: DoNotSellLinkProps) {
  return (
    <a
      href="#do-not-sell"
      className={className}
      onClick={(event) => {
        event.preventDefault()
        window.revisitCkyConsent?.()
      }}
    >
      Do Not Sell or Share My Personal Information
    </a>
  )
}
